import { TComponentParamsGeneral, THeadingTag, CardProps, LinkField, StringField } from '../../../types/types';
import { CardModel } from '../../../lib/shared-models/card.model';
import { TBlogNewsFields, TBlogNewsProps } from '../types/blogNews.types';
import { getFollowingHTag } from '../../../utils/seo.utils';

export class BlogNewsModel {
  private readonly fields?: TBlogNewsFields;
  private readonly params?: TComponentParamsGeneral;

  constructor(props: TBlogNewsProps) {
    this.fields = props?.fields;
    this.params = props?.params;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get content(): StringField | undefined {
    return this.fields?.subtitle;
  }

  get cards(): CardProps[] {
    const cardList = this.fields?.items ?? [];
    return cardList.map((el) => new CardModel(el).all);
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get link(): LinkField | undefined {
    return this.fields?.link;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get textColor(): string | undefined {
    return this.params?.textColor?.toLowerCase() || 'black';
  }

  get isGradientDisabled(): boolean | undefined {
    return this.params?.disableGradient === '1';
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h3';
  }

  get cardHeadingTitleTag(): THeadingTag {
    return getFollowingHTag(this.headingTag);
  }
}
